import angular from 'angular';
import { clickToDownloadComponent } from './clickToDownloadComponent';
import 'components/sharpr/eventTracker/eventTrackerModule';
import 'components/sharpr/storage/storageModule';

angular
	.module('sh.clickToDownload', ['sh.eventTracker', 'sh.storage'])
	.component('shClickToDownload', clickToDownloadComponent());
